export const movies = [
  {
    id: "hn-001",
    title: "热情的邻居",
    type: "电视剧",
    region: "中国大陆",
    year: 2026,
    genres: ["都市", "情感", "群像"],
    rating: 9.1,
    views: 2860000,
    status: "更新至第 12 集",
    updateDate: "2026-10-12",
    summary:
      "一栋老旧居民楼里，热情的邻居们用一日三餐、你来我往的琐碎日常，把彼此的孤独慢慢焐热。搬家第一天，女主角就撞上了楼道里那个总爱管闲事的邻居，从此开启鸡飞狗跳又温暖治愈的生活。",
    slogan: "把邻居处成家人，是一栋楼最浪漫的意外",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20warm%20drama%20poster%20of%20a%20friendly%20residential%20neighborhood%20with%20two%20neighbors%20chatting%20on%20a%20balcony%20at%20golden%20hour%2C%20deep%20crimson%20and%20charcoal%20color%20grading%2C%20moody%20dramatic%20lighting%2C%20portrait%20composition%2C%20film%20grain%2C%20elegant%20empty%20space%20at%20the%20bottom%20for%20title%20text%2C%20high%20detail%20editorial%20photography&width=600&height=900&seq=hn-poster-001&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Cinematic%20wide%20film%20still%20of%20a%20cozy%20city%20apartment%20alley%20at%20dusk%2C%20warm%20window%20lights%20glowing%2C%20neighbors%20gathering%20on%20a%20small%20street%2C%20deep%20crimson%20and%20charcoal%20tones%2C%20shallow%20depth%20of%20field%2C%20moody%20atmosphere%2C%20anamorphic%20lens%2C%20high%20detail&width=1600&height=900&seq=hn-hero-001&orientation=landscape",
    director: "周慕安",
    cast: ["林见夏", "陆则铭", "苏晚棠", "高远", "叶知秋"],
    episodes: [
      { ep: 1, title: "搬来的第一天", duration: "45 分钟", synopsis: "女主角乔迁新居，因一箱搬错门的快递，与自称社区热心人的男主角第一次正面交锋。" },
      { ep: 2, title: "一锅多事的红烧肉", duration: "45 分钟", synopsis: "楼道飘香引发邻里误会，一锅红烧肉意外成了整栋楼的社交起点。" },
      { ep: 3, title: "停水七十二小时", duration: "46 分钟", synopsis: "小区临时停水，邻居们被迫共用一间浴室，鸡毛蒜皮里生出默契。" },
      { ep: 4, title: "陌生人的旧照片", duration: "45 分钟", synopsis: "整理杂物时发现的一叠旧照片，牵出了一段被整栋楼遗忘的往事。" },
      { ep: 5, title: "楼道里的深夜电台", duration: "47 分钟", synopsis: "失眠的邻居们隔着门板聊天，把各自的秘密留在了夜里。" },
      { ep: 6, title: "台风天的避难所", duration: "45 分钟", synopsis: "台风过境，一栋楼的人挤进一楼大厅，第一次像一家人一样互相依靠。" },
      { ep: 7, title: "吵架也是一门学问", duration: "45 分钟", synopsis: "两户人家因为晾衣杆结怨，其他人被迫当起了和事佬。" },
      { ep: 8, title: "出租屋里的钢琴声", duration: "46 分钟", synopsis: "深夜传来的钢琴声让所有人安静下来，也揭开了一位邻居的旧梦。" },
      { ep: 9, title: "团购这件小事", duration: "45 分钟", synopsis: "为了省几块钱发起的团购，演变成一场全民参与的邻里狂欢。" },
      { ep: 10, title: "谁动了我的花盆", duration: "45 分钟", synopsis: "公共花坛的一盆花不翼而飞，侦探式的排查笑料百出。" },
      { ep: 11, title: "楼下那家早餐铺", duration: "47 分钟", synopsis: "经营多年的早餐铺面临关张，邻居们决定用自己的方式留住烟火气。" },
      { ep: 12, title: "把邻居处成家人", duration: "49 分钟", synopsis: "整栋楼为一次告别办了一场意外的聚会，热情终于有了回响。" },
    ],
  },
  {
    id: "hn-002",
    title: "长夜将明",
    type: "电视剧",
    region: "中国大陆",
    year: 2026,
    genres: ["悬疑", "犯罪", "剧情"],
    rating: 8.7,
    views: 2140000,
    status: "更新至第 8 集",
    updateDate: "2026-10-11",
    summary:
      "一桩尘封多年的旧案重新浮出水面，年轻的刑警与固执的老法医联手追查真相。每一个被遗忘的细节，都在长夜里等待黎明。",
    slogan: "真相从不会自己天亮",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20suspense%20drama%20poster%2C%20a%20lone%20figure%20standing%20in%20a%20dark%20rainy%20alley%20under%20a%20single%20street%20lamp%2C%20deep%20crimson%20neon%20glow%20and%20charcoal%20shadows%2C%20mysterious%20mood%2C%20portrait%20composition%2C%20film%20grain%2C%20empty%20space%20for%20title%2C%20high%20detail%20editorial&width=600&height=900&seq=hn-poster-002&orientation=portrait",
    director: "韩铮",
    cast: ["覃斯年", "方鹤鸣", "林见夏", "邹一鸣"],
    episodes: [
      { ep: 1, title: "雨夜的报警电话", duration: "44 分钟", synopsis: "一通来历不明的报警电话，让一桩沉寂十二年的旧案重新进入视野。" },
      { ep: 2, title: "被擦掉的指纹", duration: "43 分钟", synopsis: "现场唯一的关键证据被人动过手脚，调查的方向瞬间转向内部。" },
      { ep: 3, title: "老法医的抽屉", duration: "45 分钟", synopsis: "老法医从尘封的档案里翻出一份从未提交的补充报告。" },
      { ep: 4, title: "沉默的证人", duration: "44 分钟", synopsis: "唯一目击者始终保持沉默，刑警决定用另一种方式敲开他的话。" },
      { ep: 5, title: "第二场大雨", duration: "45 分钟", synopsis: "又一起相似案件发生，众人意识到凶手从未离开过这座城市。" },
      { ep: 6, title: "错位的记忆", duration: "44 分钟", synopsis: "证人的记忆出现矛盾，真相与谎言在时间线里互相拉扯。" },
      { ep: 7, title: "长夜（上）", duration: "46 分钟", synopsis: "关键的第六次比对终于出结果，长夜里第一次出现微光。" },
      { ep: 8, title: "长夜（下）", duration: "48 分钟", synopsis: "所有线索汇聚到同一个名字，代价也随之而来。" },
    ],
  },
  {
    id: "hn-003",
    title: "山海拾光",
    type: "电视剧",
    region: "中国大陆",
    year: 2025,
    genres: ["古装", "玄幻", "爱情"],
    rating: 8.4,
    views: 1980000,
    status: "全 24 集",
    updateDate: "2026-09-28",
    summary:
      "少年生于渔村，却背负着山海之间的古老誓约。当他走进那座云端之城的瞬间，一场关于守护与别离的宿命缓缓展开。",
    slogan: "踏遍山海，只为拾一段旧时光",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20ancient%20Chinese%20costume%20drama%20poster%2C%20a%20young%20warrior%20in%20flowing%20robes%20standing%20before%20misty%20mountains%20and%20a%20vast%20sea%2C%20muted%20crimson%20and%20charcoal%20palette%20with%20golden%20light%2C%20epic%20mood%2C%20portrait%20composition%2C%20film%20grain%2C%20elegant%20title%20space%2C%20high%20detail%20painterly%20style&width=600&height=900&seq=hn-poster-003&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Cinematic%20epic%20wide%20shot%20of%20ancient%20Chinese%20coastal%20cliffs%20at%20sunrise%20with%20mist%20over%20a%20sea%20of%20clouds%2C%20tiny%20warrior%20silhouette%20on%20the%20ridge%2C%20muted%20crimson%20and%20charcoal%20tones%20with%20golden%20light%2C%20anamorphic%20lens%20flare%2C%20high%20detail&width=1600&height=900&seq=hn-hero-003&orientation=landscape",
    director: "江砚白",
    cast: ["沈既明", "柳昭昭", "温子怀", "叶知秋"],
    episodes: [
      { ep: 1, title: "渔村少年", duration: "45 分钟", synopsis: "海风吹散晨雾，渔村少年在礁石上捡到一枚会发光的旧贝。" },
      { ep: 2, title: "云端之城", duration: "46 分钟", synopsis: "为还一桩人情，少年踏上了从未有人归来的云端之城的石阶。" },
      { ep: 3, title: "第一次问剑", duration: "45 分钟", synopsis: "城中比武，少年第一次握剑，也第一次被人记住名字。" },
      { ep: 4, title: "旧誓约", duration: "47 分钟", synopsis: "一卷残破的誓约卷轴，揭开了两个家族百年前的约定。" },
      { ep: 5, title: "山海之间", duration: "45 分钟", synopsis: "为了一个承诺，少年在风雪里走了七天七夜。" },
      { ep: 6, title: "拾光（上）", duration: "48 分钟", synopsis: "当守护的代价终于降临，少年选择把名字留在了山与海之间。" },
    ],
  },
  {
    id: "hn-004",
    title: "潮汐之城",
    type: "电视剧",
    region: "中国香港",
    year: 2025,
    genres: ["都市", "爱情", "生活"],
    rating: 8.2,
    views: 1560000,
    status: "全 20 集",
    updateDate: "2026-09-20",
    summary:
      "海滨城市的潮水每天准时起落，两个在深夜便利店相遇的年轻人，却始终找不到彼此靠岸的时间。一座城，一段涨落的感情。",
    slogan: "潮水退去，才知道谁在原地等",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20modern%20urban%20drama%20poster%2C%20a%20young%20couple%20walking%20along%20a%20seaside%20city%20promenade%20at%20twilight%2C%20distant%20skyscrapers%2C%20deep%20crimson%20sky%20and%20charcoal%20blue%20gray%20shadows%2C%20romantic%20melancholic%20mood%2C%20portrait%20composition%2C%20film%20grain%2C%20title%20space%20at%20bottom%2C%20high%20detail&width=600&height=900&seq=hn-poster-004&orientation=portrait",
    director: "陈以宁",
    cast: ["温子怀", "苏晚棠", "邹一鸣", "高远"],
    episodes: [
      { ep: 1, title: "凌晨两点的便利店", duration: "43 分钟", synopsis: "加班到深夜的两个人，在便利店关东煮的热气里第一次说话。" },
      { ep: 2, title: "涨潮的约定", duration: "44 分钟", synopsis: "一个临时起意的约定，被写进了手机备忘录的置顶。" },
      { ep: 3, title: "错过的末班车", duration: "43 分钟", synopsis: "末班车呼啸而过，两人隔着站台第一次认真道别。" },
      { ep: 4, title: "旧码头", duration: "45 分钟", synopsis: "废弃的旧码头藏着一座城的旧事，也藏着两个人的分歧。" },
      { ep: 5, title: "潮汐（上）", duration: "44 分钟", synopsis: "工作调动摆在面前，感情第一次走进现实的涨落。" },
      { ep: 6, title: "潮汐（下）", duration: "46 分钟", synopsis: "潮水退去，海滩上留下了一行迟迟没有说出口的话。" },
    ],
  },
  {
    id: "hn-005",
    title: "无声证词",
    type: "电影",
    region: "中国大陆",
    year: 2026,
    genres: ["犯罪", "悬疑", "剧情"],
    rating: 8.9,
    views: 1720000,
    status: "已上映",
    updateDate: "2026-10-02",
    summary:
      "一间封闭的审讯室里，嫌疑人不发一言，证据却句句作响。当沉默本身成为证词，真相与谎言只剩一线之隔。",
    slogan: "没有说出口的，往往最震耳",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20crime%20thriller%20movie%20poster%2C%20a%20detective%20silhouette%20examining%20evidence%20under%20a%20harsh%20spotlight%20in%20a%20dim%20interrogation%20room%2C%20deep%20crimson%20and%20black%20color%20grade%2C%20tense%20mood%2C%20portrait%20composition%2C%20film%20grain%2C%20empty%20title%20space%2C%20high%20detail%20editorial%20photography&width=600&height=900&seq=hn-poster-005&orientation=portrait",
    director: "韩铮",
    cast: ["覃斯年", "方鹤鸣", "叶知秋"],
    episodes: [],
  },
  {
    id: "hn-006",
    title: "第七封信",
    type: "电影",
    region: "日本",
    year: 2025,
    genres: ["爱情", "文艺", "剧情"],
    rating: 8.5,
    views: 980000,
    status: "已上映",
    updateDate: "2026-09-15",
    summary:
      "一间要拆迁的老房子里，堆着六封没寄出的信。当第七封被找到时，收信人早已在两座城市之外，把往事妥帖收起。",
    slogan: "有些话，迟到了十年才抵达",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20romantic%20film%20poster%2C%20handwritten%20letters%20and%20dried%20flowers%20scattered%20on%20an%20old%20wooden%20desk%20by%20a%20rain%20streaked%20window%2C%20deep%20crimson%20and%20charcoal%20warm%20tones%2C%20nostalgic%20gentle%20mood%2C%20portrait%20composition%2C%20film%20grain%2C%20elegant%20title%20space%2C%20high%20detail&width=600&height=900&seq=hn-poster-006&orientation=portrait",
    director: "佐野千寻",
    cast: ["柳昭昭", "沈既明", "苏晚棠"],
    episodes: [],
  },
  {
    id: "hn-007",
    title: "星际归途",
    type: "电影",
    region: "美国",
    year: 2026,
    genres: ["科幻", "冒险", "剧情"],
    rating: 8.8,
    views: 2410000,
    status: "热映中",
    updateDate: "2026-10-08",
    summary:
      "一次深空任务失败后，最后的宇航员独自漂浮在归途上。当信号里传来一段熟悉的家乡广播，回家的意义被重新定义。",
    slogan: "宇宙很大，家只有一个方向",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20science%20fiction%20movie%20poster%2C%20a%20lone%20astronaut%20before%20a%20colossal%20glowing%20ringed%20planet%2C%20deep%20crimson%20nebula%20and%20dark%20charcoal%20space%2C%20epic%20awe%20inspiring%20mood%2C%20portrait%20composition%2C%20film%20grain%2C%20empty%20title%20space%2C%20high%20detail&width=600&height=900&seq=hn-poster-007&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Cinematic%20wide%20space%20shot%20of%20a%20small%20spacecraft%20drifting%20toward%20a%20giant%20ringed%20planet%2C%20deep%20crimson%20nebula%20clouds%20and%20charcoal%20starfield%2C%20lens%20flare%2C%20epic%20cinematic%20composition%2C%20high%20detail&width=1600&height=900&seq=hn-hero-007&orientation=landscape",
    director: "A. Reeves",
    cast: ["高远", "温子怀", "叶知秋"],
    episodes: [],
  },
  {
    id: "hn-008",
    title: "春生万物",
    type: "电影",
    region: "中国大陆",
    year: 2025,
    genres: ["家庭", "剧情", "治愈"],
    rating: 8.3,
    views: 720000,
    status: "已上映",
    updateDate: "2026-08-30",
    summary:
      "一位忙碌的父亲回到乡下，陪女儿种下一棵只会在春天开花的树。四季轮转之间，父女俩都长出了新的模样。",
    slogan: "种下一棵树，等一个春天",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20family%20film%20poster%2C%20a%20father%20and%20daughter%20planting%20a%20young%20tree%20in%20a%20sunlit%20field%2C%20warm%20crimson%20and%20earthy%20charcoal%20tones%2C%20tender%20hopeful%20mood%2C%20portrait%20composition%2C%20film%20grain%2C%20gentle%20title%20space%2C%20high%20detail%20editorial%20photography&width=600&height=900&seq=hn-poster-008&orientation=portrait",
    director: "周慕安",
    cast: ["陆则铭", "叶知秋", "林见夏"],
    episodes: [],
  },
  {
    id: "hn-009",
    title: "午夜电台",
    type: "电影",
    region: "韩国",
    year: 2026,
    genres: ["惊悚", "悬疑"],
    rating: 7.9,
    views: 890000,
    status: "已上映",
    updateDate: "2026-09-26",
    summary:
      "深夜电台主持人接到一通自称来自“未来”的听众来电，电话那头的预言正在一句句变成现实。午夜十二点，节目才刚刚开始。",
    slogan: "请调整频率，接收来自午夜的声音",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20horror%20thriller%20poster%2C%20an%20old%20analog%20radio%20glowing%20in%20a%20dark%20empty%20room%2C%20deep%20crimson%20light%20leaking%20through%20a%20doorway%2C%20eerie%20unsettling%20mood%2C%20portrait%20composition%2C%20film%20grain%2C%20empty%20title%20space%2C%20high%20detail&width=600&height=900&seq=hn-poster-009&orientation=portrait",
    director: "郑河俊",
    cast: ["柳昭昭", "邹一鸣", "覃斯年"],
    episodes: [],
  },
  {
    id: "hn-010",
    title: "大厨驾到",
    type: "综艺",
    region: "中国大陆",
    year: 2026,
    genres: ["美食", "真人秀", "竞技"],
    rating: 8.0,
    views: 1130000,
    status: "更新至第 9 期",
    updateDate: "2026-10-10",
    summary:
      "十位来自民间与星级的厨师同台竞技，用一道菜讲述一个故事。厨房里的火药味与烟火气，同样令人上头。",
    slogan: "一口下去，全是故事",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20cooking%20variety%20show%20poster%2C%20a%20chef%20plating%20an%20elegant%20dish%20in%20a%20dramatic%20dark%20kitchen%2C%20bright%20yellow%20warm%20highlights%20and%20charcoal%20background%2C%20vibrant%20appetizing%20mood%2C%20portrait%20composition%2C%20film%20grain%2C%20title%20space%2C%20high%20detail%20food%20photography&width=600&height=900&seq=hn-poster-010&orientation=portrait",
    director: "节目组",
    cast: ["众位嘉宾"],
    episodes: [
      { ep: 1, title: "海选：一碗面的胜负", duration: "78 分钟", synopsis: "首期海选，五十位民间厨神只为一碗面展开角逐。" },
      { ep: 2, title: "双人组队赛", duration: "82 分钟", synopsis: "随机抽签组队，性格迥异的两位主厨被迫合作。" },
      { ep: 3, title: "记忆里的味道", duration: "80 分钟", synopsis: "主题是“家乡”，每个人端出的都是自己的童年。" },
      { ep: 4, title: "限时挑战：三十分钟", duration: "79 分钟", synopsis: "只有三十分钟和一个冰箱，有人做出了惊艳全场的作品。" },
      { ep: 5, title: "甜品大作战", duration: "81 分钟", synopsis: "向来严肃的主厨们，在甜点台上集体破防。" },
      { ep: 6, title: "户外野炊", duration: "83 分钟", synopsis: "离开厨房，在旷野里生火做饭，考验的是临场与默契。" },
    ],
  },
  {
    id: "hn-011",
    title: "奔跑吧少年",
    type: "综艺",
    region: "中国大陆",
    year: 2025,
    genres: ["竞技", "真人秀", "青春"],
    rating: 7.6,
    views: 940000,
    status: "更新至第 11 期",
    updateDate: "2026-10-05",
    summary:
      "一群热血少年在赛场上挥洒汗水，跨越障碍、并肩冲刺。输赢之外，他们真正跑赢的是那个曾经畏难的自己。",
    slogan: "青春就是，跑起来就不回头",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20sports%20variety%20show%20poster%2C%20energetic%20young%20runners%20sprinting%20on%20a%20track%20at%20sunset%2C%20bright%20yellow%20and%20crimson%20accents%20over%20charcoal%20tones%2C%20dynamic%20vibrant%20mood%2C%20portrait%20composition%2C%20film%20grain%2C%20title%20space%2C%20high%20detail&width=600&height=900&seq=hn-poster-011&orientation=portrait",
    director: "节目组",
    cast: ["少年团"],
    episodes: [
      { ep: 1, title: "百人开营赛", duration: "88 分钟", synopsis: "百位少年齐聚赛场，第一期就淘汰近半。" },
      { ep: 2, title: "团队接力", duration: "86 分钟", synopsis: "接力棒传递的不只是速度，还有信任。" },
      { ep: 3, title: "极限障碍赛", duration: "90 分钟", synopsis: "泥地、绳网、高墙，考验身体也考验意志。" },
      { ep: 4, title: "雨中突围", duration: "87 分钟", synopsis: "突降大雨，比赛是否继续成了最大的考验。" },
    ],
  },
  {
    id: "hn-012",
    title: "邻里之间",
    type: "电视剧",
    region: "中国大陆",
    year: 2024,
    genres: ["都市", "家庭", "治愈"],
    rating: 8.1,
    views: 1290000,
    status: "全 30 集",
    updateDate: "2026-08-18",
    summary:
      "一栋老楼、一张公共饭桌、一群拌嘴又相互照应的邻居。生活从不是惊天动地，而是有人在楼下等你一起吃饭。",
    slogan: "最好的日子，是有人喊你吃饭",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20neighborhood%20drama%20poster%2C%20residents%20of%20an%20old%20residential%20building%20sharing%20a%20meal%20in%20a%20courtyard%2C%20warm%20crimson%20and%20charcoal%20palette%2C%20heartwarming%20ordinary%20life%20mood%2C%20portrait%20composition%2C%20film%20grain%2C%20title%20space%2C%20high%20detail&width=600&height=900&seq=hn-poster-012&orientation=portrait",
    director: "陈以宁",
    cast: ["陆则铭", "林见夏", "苏晚棠", "高远"],
    episodes: [
      { ep: 1, title: "公共饭桌", duration: "45 分钟", synopsis: "一楼大厅那张旧桌子，成了整栋楼故事的起点。" },
      { ep: 2, title: "谁家的猫", duration: "44 分钟", synopsis: "一只流浪猫，把三户原本不来往的人家连在了一起。" },
      { ep: 3, title: "老人与旧收音机", duration: "46 分钟", synopsis: "独居老人每天准时播放的广播，藏着一段思念。" },
      { ep: 4, title: "搬家那天", duration: "45 分钟", synopsis: "有人要搬走了，邻居们用一场饭局留住最后的热闹。" },
      { ep: 5, title: "邻里之间", duration: "47 分钟", synopsis: "一整年的琐碎与温暖，在一顿年夜饭里有了答案。" },
    ],
  },
  {
    id: "hn-013",
    title: "雪落长安",
    type: "电视剧",
    region: "中国大陆",
    year: 2025,
    genres: ["古装", "历史", "爱情"],
    rating: 8.6,
    views: 1870000,
    status: "全 32 集",
    updateDate: "2026-09-08",
    summary:
      "长安落雪的冬夜，一名女子带着一份旧约走进深宫。朝堂风云与儿女情长交织，她要在漫天大雪里，找回属于自己的名字。",
    slogan: "雪落长安，愿故人如旧",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20historical%20drama%20poster%2C%20a%20graceful%20figure%20in%20winter%20robes%20standing%20on%20snow%20covered%20ancient%20palace%20steps%2C%20deep%20crimson%20lanterns%20and%20charcoal%20mist%2C%20elegant%20melancholic%20mood%2C%20portrait%20composition%2C%20film%20grain%2C%20title%20space%2C%20high%20detail%20painterly&width=600&height=900&seq=hn-poster-013&orientation=portrait",
    backdrop:
      "https://readdy.ai/api/search-image?query=Cinematic%20wide%20shot%20of%20a%20snowy%20ancient%20Chinese%20palace%20city%20at%20night%2C%20red%20lanterns%20glowing%20along%20long%20corridors%2C%20falling%20snow%2C%20charcoal%20and%20crimson%20tones%2C%20atmospheric%20mist%2C%20high%20detail&width=1600&height=900&seq=hn-hero-013&orientation=landscape",
    director: "江砚白",
    cast: ["柳昭昭", "沈既明", "温子怀", "叶知秋"],
    episodes: [
      { ep: 1, title: "初雪入宫", duration: "45 分钟", synopsis: "长安初雪，她带着一封旧约第一次踏入宫门。" },
      { ep: 2, title: "灯下夜谈", duration: "46 分钟", synopsis: "宫灯之下，一句无心之言成了日后的伏笔。" },
      { ep: 3, title: "朝堂风起", duration: "45 分钟", synopsis: "一桩旧案的翻案，让朝堂风向骤变。" },
      { ep: 4, title: "旧年梅花", duration: "47 分钟", synopsis: "墙角一枝梅花，牵出两人年幼时的相遇。" },
      { ep: 5, title: "雪落长安（上）", duration: "48 分钟", synopsis: "大雪封城，她必须在亲情与大义间做出选择。" },
      { ep: 6, title: "雪落长安（下）", duration: "49 分钟", synopsis: "雪停时，长安城与故人都等来了同一个春天。" },
    ],
  },
  {
    id: "hn-014",
    title: "追风者",
    type: "电影",
    region: "中国大陆",
    year: 2026,
    genres: ["运动", "剧情", "励志"],
    rating: 8.2,
    views: 810000,
    status: "热映中",
    updateDate: "2026-10-06",
    summary:
      "一位因伤退赛的老将，带着一群不被看好的少年车手，挑战那条从未有人完成的沿海赛道。追的不只是风，还有曾经放弃的自己。",
    slogan: "风在前面，答案在后面",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20sports%20drama%20movie%20poster%2C%20a%20cyclist%20racing%20along%20a%20coastal%20road%20at%20dawn%2C%20motion%20blur%2C%20crimson%20sunrise%20and%20charcoal%20shadows%2C%20inspiring%20energetic%20mood%2C%20portrait%20composition%2C%20film%20grain%2C%20title%20space%2C%20high%20detail&width=600&height=900&seq=hn-poster-014&orientation=portrait",
    director: "周慕安",
    cast: ["邹一鸣", "高远", "覃斯年"],
    episodes: [],
  },
  {
    id: "hn-015",
    title: "深海回声",
    type: "纪录片",
    region: "英国",
    year: 2025,
    genres: ["纪录", "自然", "人文"],
    rating: 9.0,
    views: 640000,
    status: "全 6 集",
    updateDate: "2026-07-28",
    summary:
      "潜入地球上最幽暗的深海，聆听那些从未被记录的声音。每一段回声，都是这颗星球写给人类的密语。",
    slogan: "深海从不沉默，只是无人倾听",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20nature%20documentary%20poster%2C%20a%20majestic%20whale%20swimming%20through%20deep%20dark%20ocean%20with%20rays%20of%20light%2C%20deep%20crimson%20and%20charcoal%20blue%20black%20tones%2C%20awe%20inspiring%20mood%2C%20portrait%20composition%2C%20film%20grain%2C%20title%20space%2C%20high%20detail%20underwater%20photography&width=600&height=900&seq=hn-poster-015&orientation=portrait",
    director: "BBC 自然团队",
    cast: ["旁白：叶知秋"],
    episodes: [
      { ep: 1, title: "光的尽头", duration: "52 分钟", synopsis: "越过阳光能抵达的深度，生命开始换一种方式发光。" },
      { ep: 2, title: "巨物的迁徙", duration: "53 分钟", synopsis: "跟随一头鲸，走过它一生中最重要的旅程。" },
      { ep: 3, title: "黑暗中的花园", duration: "51 分钟", synopsis: "深海热泉旁，藏着地球上最顽强的生命图景。" },
      { ep: 4, title: "声音的地图", duration: "54 分钟", synopsis: "科学家用声呐绘制出一张从未有过的深海地图。" },
      { ep: 5, title: "人类到达不了的地方", duration: "52 分钟", synopsis: "在万米之下，摄像机记录下无言的震撼。" },
      { ep: 6, title: "回声", duration: "55 分钟", synopsis: "当我们重新倾听，海洋也终于开始回应。" },
    ],
  },
  {
    id: "hn-016",
    title: "我们的夏天",
    type: "电视剧",
    region: "中国大陆",
    year: 2026,
    genres: ["青春", "校园", "治愈"],
    rating: 8.4,
    views: 1620000,
    status: "更新至第 10 集",
    updateDate: "2026-10-13",
    summary:
      "毕业前的最后一个夏天，四个性格迥异的少年在屋顶架起了望远镜。他们约好去看一场流星雨，也约好不管走多远都要记得彼此。",
    slogan: "那个夏天，我们都不舍得说再见",
    poster:
      "https://readdy.ai/api/search-image?query=Cinematic%20youth%20drama%20poster%2C%20a%20group%20of%20teenagers%20laughing%20on%20a%20rooftop%20at%20summer%20sunset%2C%20warm%20crimson%20and%20charcoal%20tones%2C%20nostalgic%20vibrant%20mood%2C%20portrait%20composition%2C%20film%20grain%2C%20title%20space%2C%20high%20detail%20editorial%20photography&width=600&height=900&seq=hn-poster-016&orientation=portrait",
    director: "陈以宁",
    cast: ["叶知秋", "林见夏", "苏晚棠", "邹一鸣"],
    episodes: [
      { ep: 1, title: "屋顶上的望远镜", duration: "44 分钟", synopsis: "四个少年在废弃楼顶拼出一台望远镜，也拼出一段友谊。" },
      { ep: 2, title: "没寄出的明信片", duration: "43 分钟", synopsis: "一张写了一半的明信片，藏着说不出口的心事。" },
      { ep: 3, title: "补习班的秘密", duration: "45 分钟", synopsis: "为了不散伙，大家瞒着彼此偷偷努力。" },
      { ep: 4, title: "天台上的坦白", duration: "44 分钟", synopsis: "一场争吵撕开了每个人心里的那道口子。" },
      { ep: 5, title: "流星雨之夜", duration: "46 分钟", synopsis: "考试前夜，四人爬上屋顶等一场预告中的流星雨。" },
      { ep: 6, title: "我们的夏天", duration: "47 分钟", synopsis: "夏天结束，他们把约定写进了同一本笔记本。" },
    ],
  },
  {
    id: "hn-017",
    title: "归途列车",
    type: "电影",
    region: "中国大陆",
    year: 2024,
    genres: ["剧情", "家庭"],
    rating: 8.0,
    views: 560000,
    status: "已上映",
    updateDate: "2026-07-12",
    summary: "一趟开往故乡的夜班列车，让多年未归的父子重新坐到了同一张餐车前，把没说出口的话留在了铁轨之间。",
    slogan: "回家的路，永远不算太远",
    poster: "https://readdy.ai/api/search-image?query=Cinematic%20family%20drama%20poster%2C%20a%20father%20and%20son%20sitting%20across%20a%20narrow%20train%20dining%20table%20at%20night%2C%20warm%20crimson%20lamp%20light%20and%20charcoal%20shadows%2C%20quiet%20emotional%20mood%2C%20portrait%20composition%2C%20film%20grain%2C%20title%20space%2C%20high%20detail&width=600&height=900&seq=hn-poster-017&orientation=portrait",
    director: "周慕安",
    cast: ["陆则铭", "高远"],
    episodes: [],
  },
  {
    id: "hn-018",
    title: "纸上月光",
    type: "电影",
    region: "日本",
    year: 2025,
    genres: ["文艺", "爱情"],
    rating: 8.1,
    views: 430000,
    status: "已上映",
    updateDate: "2026-06-30",
    summary: "一位写不出下一本书的作家，搬进一间老书店阁楼。整理旧书时，他读到了二十年前一位读者的批注，也读到了自己。",
    slogan: "有些故事，是写给未来的读者",
    poster: "https://readdy.ai/api/search-image?query=Cinematic%20literary%20romance%20poster%2C%20a%20writer%20reading%20an%20annotated%20old%20book%20in%20a%20dim%20bookstore%20attic%2C%20moonlight%20through%20a%20small%20window%2C%20deep%20crimson%20and%20charcoal%20tones%2C%20quiet%20melancholic%20mood%2C%20portrait%20composition%2C%20film%20grain%2C%20title%20space%2C%20high%20detail&width=600&height=900&seq=hn-poster-018&orientation=portrait",
    director: "佐野千寻",
    cast: ["柳昭昭", "温子怀"],
    episodes: [],
  },
  {
    id: "hn-019",
    title: "钢铁之心",
    type: "电视剧",
    region: "美国",
    year: 2026,
    genres: ["科幻", "剧情", "冒险"],
    rating: 8.3,
    views: 1340000,
    status: "更新至第 6 集",
    updateDate: "2026-10-09",
    summary: "在资源枯竭的未来都市，一名机械工程师试图用一台旧机器重启城市的能源系统，却发现真相远比钢铁更坚硬。",
    slogan: "机器会生锈，信念不会",
    poster: "https://readdy.ai/api/search-image?query=Cinematic%20science%20fiction%20series%20poster%2C%20a%20female%20engineer%20standing%20before%20a%20massive%20rusty%20machine%20in%20a%20dark%20industrial%20city%2C%20deep%20crimson%20warning%20lights%20and%20charcoal%20smoke%2C%20gritty%20mood%2C%20portrait%20composition%2C%20film%20grain%2C%20title%20space%2C%20high%20detail&width=600&height=900&seq=hn-poster-019&orientation=portrait",
    director: "M. Cole",
    cast: ["高远", "叶知秋", "覃斯年"],
    episodes: [
      { ep: 1, title: "停转的城市", duration: "48 分钟", synopsis: "城市能源核心突然停转，工程师被紧急召回旧厂区。" },
      { ep: 2, title: "旧机器的秘密", duration: "47 分钟", synopsis: "一台被封存的旧机器上，刻着一组不该存在的编号。" },
      { ep: 3, title: "钢铁之下", duration: "48 分钟", synopsis: "调查越深入，越接近一段被刻意抹去的历史。" },
      { ep: 4, title: "重启", duration: "49 分钟", synopsis: "为了重启系统，她必须赌上自己的一切。" },
    ],
  },
  {
    id: "hn-020",
    title: "老街剪影",
    type: "电视剧",
    region: "中国香港",
    year: 2024,
    genres: ["都市", "生活"],
    rating: 7.8,
    views: 480000,
    status: "全 18 集",
    updateDate: "2026-05-20",
    summary: "一条即将拆迁的老街上，裁缝铺、凉茶档、照相馆的老板们，用最后的半年，把这条街的故事一针一线缝了下来。",
    slogan: "老街会消失，记忆不会",
    poster: "https://readdy.ai/api/search-image?query=Cinematic%20urban%20life%20drama%20poster%2C%20shopkeepers%20on%20a%20narrow%20old%20street%20at%20dusk%2C%20neon%20signs%20and%20hanging%20lanterns%2C%20deep%20crimson%20and%20charcoal%20tones%2C%20nostalgic%20warm%20mood%2C%20portrait%20composition%2C%20film%20grain%2C%20title%20space%2C%20high%20detail&width=600&height=900&seq=hn-poster-020&orientation=portrait",
    director: "陈以宁",
    cast: ["苏晚棠", "邹一鸣"],
    episodes: [],
  },
  {
    id: "hn-021",
    title: "厨房里的哲学家",
    type: "综艺",
    region: "中国大陆",
    year: 2025,
    genres: ["美食", "访谈"],
    rating: 8.2,
    views: 690000,
    status: "全 12 期",
    updateDate: "2026-06-08",
    summary: "每期请来一位嘉宾，边做一道家常菜边聊人生。锅里翻炒的是菜，桌上传开的是故事。",
    slogan: "所有大道理，都藏在家常菜里",
    poster: "https://readdy.ai/api/search-image?query=Cinematic%20talk%20variety%20show%20poster%2C%20two%20people%20cooking%20and%20chatting%20in%20a%20warm%20home%20kitchen%2C%20bright%20yellow%20highlights%20over%20charcoal%20background%2C%20cozy%20conversational%20mood%2C%20portrait%20composition%2C%20film%20grain%2C%20title%20space%2C%20high%20detail&width=600&height=900&seq=hn-poster-021&orientation=portrait",
    director: "节目组",
    cast: ["众位嘉宾"],
    episodes: [],
  },
  {
    id: "hn-022",
    title: "荒野之声",
    type: "纪录片",
    region: "英国",
    year: 2026,
    genres: ["纪录", "自然"],
    rating: 9.2,
    views: 520000,
    status: "全 8 集",
    updateDate: "2026-09-30",
    summary: "从高原到雨林，摄制组用一年时间记录下十二种濒危动物的迁徙。每一个脚印，都是荒野写给地球的信。",
    slogan: "荒野在说话，请安静地听",
    poster: "https://readdy.ai/api/search-image?query=Cinematic%20nature%20documentary%20poster%2C%20a%20lone%20snow%20leopard%20on%20a%20misty%20highland%20ridge%20at%20dawn%2C%20deep%20crimson%20sun%20and%20charcoal%20mist%2C%20majestic%20solemn%20mood%2C%20portrait%20composition%2C%20film%20grain%2C%20title%20space%2C%20high%20detail&width=600&height=900&seq=hn-poster-022&orientation=portrait",
    director: "BBC 自然团队",
    cast: ["旁白：叶知秋"],
    episodes: [],
  },
  {
    id: "hn-023",
    title: "第五个季节",
    type: "电影",
    region: "韩国",
    year: 2025,
    genres: ["剧情", "悬疑"],
    rating: 8.4,
    views: 760000,
    status: "已上映",
    updateDate: "2026-08-22",
    summary: "一座小城每四年会出现一个没有记录的“第五个季节”，而每次出现，都有人消失。今年的季节，又要开始了。",
    slogan: "有些季节，不属于任何日历",
    poster: "https://readdy.ai/api/search-image?query=Cinematic%20mystery%20drama%20poster%2C%20a%20small%20town%20street%20frozen%20in%20an%20uncanny%20season%2C%20odd%20crimson%20haze%20and%20charcoal%20shadow%2C%20unsettling%20quiet%20mood%2C%20portrait%20composition%2C%20film%20grain%2C%20title%20space%2C%20high%20detail&width=600&height=900&seq=hn-poster-023&orientation=portrait",
    director: "郑河俊",
    cast: ["覃斯年", "柳昭昭"],
    episodes: [],
  },
  {
    id: "hn-024",
    title: "星河列车",
    type: "电视剧",
    region: "中国大陆",
    year: 2026,
    genres: ["科幻", "爱情"],
    rating: 8.0,
    views: 1210000,
    status: "更新至第 7 集",
    updateDate: "2026-10-04",
    summary: "一辆穿越星河的列车，载着形形色色的旅客。两位素不相识的人在同一节车厢相遇，却各自带着一段无法抵达的过去。",
    slogan: "这趟列车，终点是彼此",
    poster: "https://readdy.ai/api/search-image?query=Cinematic%20sci%20fi%20romance%20drama%20poster%2C%20two%20passengers%20in%20a%20futuristic%20train%20carriage%20looking%20out%20at%20a%20crimson%20starfield%2C%20charcoal%20metallic%20interior%2C%20dreamy%20melancholic%20mood%2C%20portrait%20composition%2C%20film%20grain%2C%20title%20space%2C%20high%20detail&width=600&height=900&seq=hn-poster-024&orientation=portrait",
    director: "江砚白",
    cast: ["沈既明", "林见夏", "温子怀"],
    episodes: [
      { ep: 1, title: "第七节车厢", duration: "45 分钟", synopsis: "列车上的一节车厢永远锁着，直到某天被人从里面推开。" },
      { ep: 2, title: "没有返程的旅程", duration: "44 分钟", synopsis: "乘客们渐渐意识到，这趟车没有回头路。" },
      { ep: 3, title: "失重的告白", duration: "45 分钟", synopsis: "在失重的货舱里，两个人心照不宣地说出了同一句话。" },
      { ep: 4, title: "星河尽头", duration: "46 分钟", synopsis: "终点站比想象中更近，也比想象中更难抵达。" },
    ],
  },
  {
    id: "hn-025",
    title: "笑忘江湖",
    type: "电视剧",
    region: "中国大陆",
    year: 2025,
    genres: ["古装", "喜剧"],
    rating: 7.9,
    views: 880000,
    status: "全 24 集",
    updateDate: "2026-07-05",
    summary: "一个只想开酒馆的落魄少侠，被迫卷入江湖纷争。刀光剑影里，他最大的心愿始终是今天的酒别卖完。",
    slogan: "江湖再大，不如一坛好酒",
    poster: "https://readdy.ai/api/search-image?query=Cinematic%20ancient%20Chinese%20comedy%20drama%20poster%2C%20a%20young%20swordsman%20carrying%20a%20wine%20jar%20through%20a%20lively%20old%20town%20street%2C%20warm%20crimson%20lanterns%20and%20charcoal%20tones%2C%20cheerful%20playful%20mood%2C%20portrait%20composition%2C%20film%20grain%2C%20title%20space%2C%20high%20detail%20painterly&width=600&height=900&seq=hn-poster-025&orientation=portrait",
    director: "沈书辞",
    cast: ["沈既明", "邹一鸣"],
    episodes: [],
  },
  {
    id: "hn-026",
    title: "一分钟的勇气",
    type: "电影",
    region: "中国大陆",
    year: 2024,
    genres: ["励志", "剧情"],
    rating: 7.7,
    views: 390000,
    status: "已上映",
    updateDate: "2026-05-10",
    summary: "一位口吃的年轻人在公开演讲比赛中报名参赛。从上台到开口的一分钟，是他这辈子走过最长的一段路。",
    slogan: "坚持一分钟，就可以是一辈子",
    poster: "https://readdy.ai/api/search-image?query=Cinematic%20inspiring%20drama%20poster%2C%20a%20nervous%20young%20speaker%20standing%20alone%20on%20a%20spotlit%20stage%2C%20warm%20crimson%20spotlight%20and%20deep%20charcoal%20background%2C%20hopeful%20tense%20mood%2C%20portrait%20composition%2C%20film%20grain%2C%20title%20space%2C%20high%20detail&width=600&height=900&seq=hn-poster-026&orientation=portrait",
    director: "周慕安",
    cast: ["邹一鸣", "苏晚棠"],
    episodes: [],
  },
  {
    id: "hn-027",
    title: "谜城日记",
    type: "电视剧",
    region: "中国香港",
    year: 2026,
    genres: ["悬疑", "犯罪"],
    rating: 8.5,
    views: 1450000,
    status: "更新至第 9 集",
    updateDate: "2026-10-07",
    summary: "一本被遗落在巴士上的日记，记录着十起尚未发生的案件。刑警翻开它的那一刻，时间开始倒计时。",
    slogan: "日记翻到最后一页，真相才开始",
    poster: "https://readdy.ai/api/search-image?query=Cinematic%20crime%20suspense%20series%20poster%2C%20a%20leather%20diary%20on%20a%20rainy%20city%20street%20bench%20at%20night%2C%20deep%20crimson%20neon%20reflections%20and%20charcoal%20shadows%2C%20tense%20mysterious%20mood%2C%20portrait%20composition%2C%20film%20grain%2C%20title%20space%2C%20high%20detail&width=600&height=900&seq=hn-poster-027&orientation=portrait",
    director: "陈以宁",
    cast: ["覃斯年", "苏晚棠", "高远"],
    episodes: [
      { ep: 1, title: "遗失的日记", duration: "46 分钟", synopsis: "一本无人认领的日记，记录了三天后才会发生的事。" },
      { ep: 2, title: "第二个签名", duration: "45 分钟", synopsis: "日记上的笔迹，竟然与一名失踪者的档案完全一致。" },
      { ep: 3, title: "倒计时", duration: "45 分钟", synopsis: "距离日记记载的下一起案件，只剩二十四小时。" },
      { ep: 4, title: "作者是谁", duration: "46 分钟", synopsis: "当所有人都在猜作者，日记却自己翻到了下一页。" },
    ],
  },
  {
    id: "hn-028",
    title: "春日迟迟",
    type: "综艺",
    region: "中国大陆",
    year: 2026,
    genres: ["生活", "慢综艺"],
    rating: 7.5,
    views: 610000,
    status: "更新至第 5 期",
    updateDate: "2026-10-01",
    summary: "一群人在郊外小院度过一整个春天，种花、做饭、发呆。没有任务，只有被慢慢拉长的时光。",
    slogan: "把日子过慢一点，再慢一点",
    poster: "https://readdy.ai/api/search-image?query=Cinematic%20slow%20life%20variety%20poster%2C%20people%20relaxing%20in%20a%20sunny%20countryside%20courtyard%20full%20of%20spring%20flowers%2C%20warm%20crimson%20and%20soft%20charcoal%20tones%2C%20peaceful%20gentle%20mood%2C%20portrait%20composition%2C%20film%20grain%2C%20title%20space%2C%20high%20detail&width=600&height=900&seq=hn-poster-028&orientation=portrait",
    director: "节目组",
    cast: ["众位嘉宾"],
    episodes: [],
  },
];

export const categoryQuickLinks = [
  { key: "电视剧", label: "电视剧", icon: "ri-tv-2-line", desc: "热门剧集持续更新" },
  { key: "电影", label: "电影", icon: "ri-film-line", desc: "院线新片与经典" },
  { key: "综艺", label: "综艺", icon: "ri-mic-line", desc: "轻松娱乐首选" },
  { key: "纪录片", label: "纪录片", icon: "ri-earth-line", desc: "看见真实的世界" },
];

export const regionOptions = ["全部", "中国大陆", "中国香港", "美国", "日本", "韩国", "英国"];
export const yearOptions = ["全部", "2026", "2025", "2024"];
export const typeOptions = ["全部", "电视剧", "电影", "综艺", "纪录片"];
export const sortOptions = [
  { key: "update", label: "按更新时间" },
  { key: "hot", label: "按热度" },
  { key: "rating", label: "按评分" },
];